import { FC, SVGAttributes } from 'react';

const EyesClose: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        d="M12 8.09961C12.4848 8.09961 12.9489 8.18806 13.3771 8.34971L11.8196 9.90725C10.8037 9.9937 9.99413 10.8033 9.90768 11.8192L8.35013 13.3767C8.18849 12.9485 8.10004 12.4844 8.10004 11.9996C8.10004 9.8457 9.84613 8.09961 12 8.09961Z"
        fill="currentColor"
      />
      <path
        d="M16.5994 5.12744C15.2936 4.50526 13.7653 4.09961 12 4.09961C5.42888 4.09961 2.14273 9.72042 1.38249 11.2076C1.12641 11.7086 1.12641 12.2906 1.38249 12.7916C1.7744 13.5583 2.83759 15.4235 4.67603 17.0508L5.95192 15.7749C4.35457 14.3935 3.39382 12.7658 2.99924 11.9996C3.75535 10.5315 6.5904 5.89961 12 5.89961C13.201 5.89961 14.2751 6.1279 15.2277 6.49917L16.5994 5.12744Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6364 4.36321C20.9879 4.71469 20.9879 5.28453 20.6364 5.63601L19.324 6.94839C21.1625 8.57576 22.2257 10.441 22.6176 11.2076C22.8737 11.7086 22.8737 12.2906 22.6176 12.7916C21.8574 14.2788 18.5712 19.8996 12 19.8996C10.2347 19.8996 8.70652 19.494 7.40066 18.8718L5.63643 20.636C5.28496 20.9875 4.71511 20.9875 4.36364 20.636C4.01217 20.2845 4.01217 19.7147 4.36364 19.3632L19.3636 4.36321C19.7151 4.01174 20.285 4.01174 20.6364 4.36321ZM18.0482 8.22428L15.6499 10.6225C15.8116 11.0507 15.9 11.5148 15.9 11.9996C15.9 14.1535 14.1539 15.8996 12 15.8996C11.5153 15.8996 11.0511 15.8112 10.6229 15.6495L8.77239 17.5C9.725 17.8713 10.7991 18.0996 12 18.0996C17.4097 18.0996 20.2447 13.4677 21.0008 11.9996C20.6063 11.2335 19.6455 9.60571 18.0482 8.22428ZM12.1807 14.0916C13.1965 14.0052 14.0061 13.1955 14.0926 12.1797L12.1807 14.0916Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default EyesClose;
